import { Getter } from "vuex";
import state, { IState } from './state';

const getChildrenUrl: Getter<IState, IState> = (state) => state.apiURLs.getChildren;
const menuItems: Getter<IState, IState> = (state) => state.menuItems;
const translations: Getter<IState, IState> = (state) => state.translations;
const extraLinks: Getter<IState, IState> = (state) => state.extraLinks;
const className: Getter<IState, IState> = (state) => state.className;
const topLinks: Getter<IState, IState> = (state) => state.topLinks;
const campaignWeb: Getter<IState, IState> = (state) => state.campaignWeb;

export default {
	getChildrenUrl,
	menuItems,
	translations,
	extraLinks,
	className,
	topLinks,
	campaignWeb
}
